export const STAGE_CODE_PARAM = 'stage_code'
export const STAGE_SUB_PARAM = 'sub'
export const DEFAULT_STAGE_CODE = 'GROUP_STAGE'
export const COMBINED_STAGE_CODE = 'SEMI_FINALS, THIRD_PLACE'
export const SEMI_FINALS_CODES = ['SEMI_FINALS', 'THIRD_PLACE']

export const resolveStageCode = (code) => {
  if (SEMI_FINALS_CODES.includes(code)) return COMBINED_STAGE_CODE
  return code || DEFAULT_STAGE_CODE
}
